import { Root } from './Debug.style'

const Debug = ({ children }) => {
  return <Root>{JSON.stringify(children, null, 2)}</Root>
}

Debug.propTypes = {}

Debug.defaultProps = {}

export default Debug
